module.exports = __webpack_public_path__ + "img/5-2.ab91e79e.png";